import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

import appDrawerWidth from '../../utils/appDrawerWidth';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      // NOTE on bigger screens permanent navigation drawer is displayed on the
      // left
      marginLeft: ({ enableMenu }) => enableMenu && appDrawerWidth,
    },
  },
  // NOTE necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
}));

const AppContent = ({ enableMenu, children }) => {
  const classes = useStyles({ enableMenu });

  return (
    <main className={classes.root}>
      <div className={classes.toolbar} />
      {children}
    </main>
  );
};

AppContent.defaultProps = {
  enableMenu: false,
};

AppContent.propTypes = {
  enableMenu: PropTypes.bool,
  children: PropTypes.node,
};

export default AppContent;
